var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushdownError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c60f13",
    fillRule: "evenodd",
    d: "M8.292 1.5a1.5 1.5 0 0 0-1.06.44L1.938 7.23a1.5 1.5 0 0 0-.439 1.06v7.417c0 .398.158.78.44 1.06L7.23 22.06a1.5 1.5 0 0 0 1.06.439h7.417a1.5 1.5 0 0 0 1.06-.44l5.293-5.291a1.5 1.5 0 0 0 .439-1.06V8.291a1.5 1.5 0 0 0-.44-1.06L16.77 1.938a1.5 1.5 0 0 0-1.06-.439zM12 5.625a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1m0 10.75a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushdownError);
export default __webpack_public_path__ + "static/media/pushdown-error.64b6635ad22a3d59b4f6c2b0e8fe0a41.svg";
export { ForwardRef as ReactComponent };